import React from "react";
import { Box } from "@mui/material";
import {
  HeroBannerHighlight,
  HeroBannerContainer,
  HeroBannerImage,
  HeroBannerTitle,
  HeroBannerWrapper,
} from "../styles/components";

const HeroBannner = () => {
  return (
    <HeroBannerWrapper>
      <HeroBannerContainer>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <HeroBannerTitle sx={{ alignItems: "center" }}>
          <HeroBannerHighlight> Hey Texas!</HeroBannerHighlight> <br/> Switching
          doesn’t <br />
          need to be complicated
        </HeroBannerTitle>
        </Box>

        <HeroBannerImage src="/images/landingpagev2/hero-img-desktop.png" alt="" />
      </HeroBannerContainer>
    </HeroBannerWrapper>
  );
};

export default HeroBannner;
